import { render, staticRenderFns } from "./DonutChartV2.vue?vue&type=template&id=07d11c68&scoped=true"
import script from "./DonutChartV2.vue?vue&type=script&lang=js"
export * from "./DonutChartV2.vue?vue&type=script&lang=js"
import style0 from "./DonutChartV2.vue?vue&type=style&index=0&id=07d11c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d11c68",
  null
  
)

export default component.exports